import Backbone from 'backbone'
import $ from 'jquery'
import template from './reports-wizard-body.hbs'
import _ from 'lodash'

//private function to clean and regenerate body views
var createView = function(body) {
	//remove previous view
	if (body.content) {
		body.content.remove()
	}

	var step = body.model.currentStep()
	let viewOpts = _.defaults({
		model: body.model.currentModel(),
		filterType: body.model.get('filterType')
	}, step.viewOptions || {})
	return new step.view(viewOpts)
}

/**
 * Delegating view that render the body of the wizard depending on what report
 * and step the user is in
 */
var Body = Backbone.View.extend({

	className: 'dialog-body dark',

	initialize: function() {
		//when the state is changes the step it's on, re-render the view
		this.listenTo(this.model, {
			'change:index': this.render
		})
	},

	render: function() {
		//generate & render the view, replacing whatever was previously there
		this.content = createView(this)
		var innerHtml = $(template()).append(this.content.render().el)
		this.$el.html(innerHtml)

		// If the view we just inserted is a multi-tree-selector, we're going to
		// need to setup its twoColumnsDetailsForm now that the view is in the DOM
		if (this.content.className.indexOf('multi-tree-selector') >= 0) {
			this.content.setupTwoColumnDetailsForm()
		}

		_.invoke(this.content, 'secure')
		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.content && this.content.remove()
	}

})

export default Body

Body.__filename__ = 'reports/wizard/reports-wizard-body.js'
